module.exports = __webpack_public_path__ + "media/Components/fonts/boldBitter-0f65a42ed90d10e60d43473aa8ffdfb9.ttf";